import { useDevice } from "@lookiero/aurora";
const useScreenSize = () => {
    const { screen } = useDevice();
    const screenSize = Object.entries(screen)
        .filter(([key]) => ["S", "M", "L"].includes(key))
        .find(([, value]) => value);
    return screenSize?.[0];
};
export { useScreenSize };
